import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import pwd from '../pwd.js'

import Vant from 'vant'
import 'vant/lib/index.css';

// main.js
import * as echarts from "echarts"
Vue.prototype.$echarts = echarts


Vue.use(Vant);


import axios from 'axios'
axios.defaults.baseURL = 'https://api.gizwits.com/'//请求的根路径

axios.defaults.headers.common['X-Gizwits-Application-Id'] = 'd8fa29e480f04baaad84c9006f089eb9'

Vue.prototype.$http = axios
axios.interceptors.request.use(
    config => {
       
        console.log(config)
        
        if(config.method == 'post'){
            config.headers['Content-Type'] ='application/x-www-form-urlencoded';
            
            config.data = JSON.stringify(config.data);//将 JavaScript 值转换为 JSON 字符串。
        }
        if (pwd.appid) { //判断token是否存在，是则请求头加上该请求头，不是则返回错误打印信息
            config.headers.common['X-Gizwits-Application-Id'] = pwd.appid;
            config.headers.common['X-Gizwits-User-token'] = pwd.token //将token设置成请求头
        }
        return config;
        
    },
    err => {
        return Promise.reject(err);
    }
);

// JSON


Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')